import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstance} from "../../Apis/Axios";
import {DOCUMENTATION_APPROVAL_SERVICE} from "../EndPoints";


export const GetDocumentApprovalFlowById = createAsyncThunk(
    'documentationApprovalSection/getDocumentApprovalFlowById',
    async (id) => {
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentApprovalFlowById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const CreateDocumentationApprovalFlow = createAsyncThunk(
    'documentationApprovalSection/createDocumentationApprovalFlow',
    async (params) => {
        const response = await apiInstance.post(`${DOCUMENTATION_APPROVAL_SERVICE.createDocumentationApprovalFlow}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);


export const DeleteDocumentationApprovalFlowByIds = createAsyncThunk(
    'documentationApprovalSection/deleteDocumentationApprovalFlowByIds',
    async (ids) => {
        const response = await apiInstance.post(`${DOCUMENTATION_APPROVAL_SERVICE.deleteDocumentationApprovalFlowByIds}`, ids
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);


export const UpdateDocumentationApprovalFlow = createAsyncThunk(
    'documentationApprovalSection/updateDocumentationApprovalFlow',
    async (params) => {
        const response = await apiInstance.put(`${DOCUMENTATION_APPROVAL_SERVICE.updateDocumentationApprovalFlow}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);

export const GetActiveDocumentUserList = createAsyncThunk(
    'documentationApprovalSection/getActiveDocumentUserList',
    async (params) => {
        const { userTypeId, userId, profile } = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.baseDocumentationUser}${userTypeId}/${userId}/${profile}${DOCUMENTATION_APPROVAL_SERVICE.getActiveDocumentUserList}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetActiveDocumentVehicleList = createAsyncThunk(
    'documentationApprovalSection/getActiveDocumentVehicleList',
    async (params) => {
        const { userTypeId, vehicleId } = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.baseDocumentationVehicle}${userTypeId}/${vehicleId}${DOCUMENTATION_APPROVAL_SERVICE.getActiveDocumentVehicleList}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);



// -------------------------------- DOCUMENTATION APPROVAL USER -------------------------------- //
export const GetDocumentationRequestByUserTypeIdAndProviderId = createAsyncThunk(
    'documentationApprovalSection/getDocumentationRequestByUserTypeIdAndProviderId',
    async (params) => {
        const {id, userTypeId} = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationRequestByUserTypeIdAndProviderId}${userTypeId}/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetDocumentationUserByUserId = createAsyncThunk(
    'documentationApprovalSection/getDocumentationUserByUserId',
    async (params) => {
        const {id, userTypeId} = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationUserByUserId}${userTypeId}/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetDocumentationUserFlowByUserId = createAsyncThunk(
    'documentationApprovalSection/getDocumentationUserFlowByUserId',
    async (params) => {
        const {id , userTypeId} = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationUserFlowByUserId}${id}/${userTypeId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetDocumentationVehicleFlowByUserId = createAsyncThunk(
    'documentationApprovalSection/getDocumentationVehicleFlowByUserId',
    async (params) => {
        const {id , userTypeId} = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationVehicleFlowByUserId}${id}/${userTypeId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetDocumentationVehicleByVehicleId = createAsyncThunk(
    'documentationApprovalSection/getDocumentationVehicleByVehicleId',
    async (params) => {
        const {id,userTypeId } = params;
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationVehicleByVehicleId}${userTypeId}/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const DocumentationUserUpdateStatusById = createAsyncThunk(
    'documentationApprovalSection/documentationUserUpdateStatusById',
    async (params) => {
        const result = await apiInstance
            .put(`${DOCUMENTATION_APPROVAL_SERVICE.documentationUserUpdateStatusById}`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const DocumentationUserUpdateStatusByUserIds = createAsyncThunk(
    'documentationApprovalSection/documentationUserUpdateStatusByUserIds',
    async (params) => {
        const result = await apiInstance
            .put(`${DOCUMENTATION_APPROVAL_SERVICE.documentationUserUpdateStatusByUserIds}`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const DocumentationVehicleUpdateStatusById = createAsyncThunk(
    'documentationApprovalSection/documentationVehicleUpdateStatusById',
    async (params) => {
        const result = await apiInstance
            .put(`${DOCUMENTATION_APPROVAL_SERVICE.documentationVehicleUpdateStatusById}`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const DocumentationVehicleUpdateStatusByVehicleIds = createAsyncThunk(
    'documentationApprovalSection/documentationVehicleUpdateStatusByVehicleIds',
    async (params) => {
        const result = await apiInstance
            .put(`${DOCUMENTATION_APPROVAL_SERVICE.documentationVehicleUpdateStatusByVehicleIds}`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetActiveDocumentApprovalPeriod = createAsyncThunk(
    'documentationApprovalSection/getActiveDocumentApprovalPeriod',
    async (params) => {
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getActiveDocumentApprovalPeriod}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetUploadDocumentApprovalPeriod = createAsyncThunk(
    'documentationApprovalSection/getUploadDocumentApprovalPeriod',
    async (params) => {
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getUploadDocumentApprovalPeriod}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetDocumentationApprovalFlowByOptions = createAsyncThunk(
    'documentationApprovalSection/getDocumentationApprovalFlowByOptions',
    async (params) => {
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationApprovalFlowByOptions}`,{params})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const CreateDocumentationApprovalUserLevel = createAsyncThunk(
    'documentationApprovalSection/createDocumentationApprovalUserLevel',
    async (params) => {
        const response = await apiInstance.post(`${DOCUMENTATION_APPROVAL_SERVICE.createDocumentationApprovalUserLevel}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);


export const GetDocumentationApprovalFlowByVehicleOptions = createAsyncThunk(
    'documentationApprovalSection/getDocumentationApprovalFlowByVehicleOptions',
    async (params) => {
        const result = await apiInstance
            .get(`${DOCUMENTATION_APPROVAL_SERVICE.getDocumentationApprovalFlowByVehicleOptions}`,{params})
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const CreateDocumentationApprovalVehicleLevel = createAsyncThunk(
    'documentationApprovalSection/createDocumentationApprovalVehicleLevel',
    async (params) => {
        const response = await apiInstance.post(`${DOCUMENTATION_APPROVAL_SERVICE.createDocumentationApprovalVehicleLevel}`, params
        ).then(function (response) {
            return response
        }).catch(function (error) {
            return error.response
        })
        const { data, status } = response

        return { data, status }
    }
);

